import { OverlaysState, Overlay } from './types';

export const getOverlayById = (overlayState: OverlaysState, id: string): Overlay => ({ ...overlayState.byIds[id] });

export const isAnyOverlayActive = (overlayState: OverlaysState): boolean =>
    Object.values(overlayState.byIds).some((overlay: Overlay) => overlay.isActive);
